export default "__VITE_ASSET__DA7u5TLC__"